import { Root } from 'react-dom/client';
import { AddBizReactLoader } from '../../Js/React/loader';
import ObjectMiniList, { ListObject, ObjectType } from './ObjectMiniList';
import BizUnsplashCredits from '../../FrontEndReact/src/Core/Components/BizMediabank/BizUnsplashCredits';

const addLoader = (e) => {
	console.log('ObjectMiniList', e);
	const params = (
		e.detail as { params: { objects: ListObject[]; limit: number; type?: string; layout?: string; layoutMobile?: string } }
	).params;

	const parseType = (type: string | undefined): ObjectType | undefined => {
		if (!type) return undefined;
		return type.toUpperCase() as ObjectType;
	};

	const type = parseType(params.type);

	return (
		<ObjectMiniList
			objects={params.objects}
			limit={params.limit}
			type={type}
			layout={params.layout}
			layoutMobile={params.layoutMobile}
		/>
	);
};

let root: Root | undefined;
AddBizReactLoader(root, 'bizobjectminilist_blog', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_media', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_education', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_start_journey', addLoader);
AddBizReactLoader(root, 'bizobjectminilist_start_journey_mobile', addLoader);

AddBizReactLoader(root, 'bizunsplashcredits', (e) => {
	const params = (e.detail as { params: { imageUrl: string } }).params;
	return <BizUnsplashCredits imageUrl={params.imageUrl} />;
});
